import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Vuelidate from 'vuelidate';
// import { VueReCaptcha } from 'vue-recaptcha-v3';

import axios from 'axios';

import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import AxiosPlugin from './plugins/axios'


import './plugins/base'
import './plugins/meta'

import messages from './config/translations'


// Vue i18n
// Vue.use(VueI18n);
// Vuelidate
Vue.use(Vuelidate);

console.log('vues env: ', process.env.NODE_ENV);
console.log(process.env.NODE_ENV === 'production' ? 'prod' : 'dev');



// Recaptcha V3
// const captcha_v3_key = process.env.NODE_ENV === 'production'
//   ? '6Lf7KMcZAAAAAEXeE722lm17H_mAqF-35XDJic-i'
//   : '6LcbosoZAAAAAPokl2BhJ-p41MtU-ZqhYQt4E8cr';
// Vue.use(VueReCaptcha, { siteKey: captcha_v3_key });


Vue.use(AxiosPlugin, router, axios)

Vue.config.productionTip = false;


// Internationalization support
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: window.navigator.language.substr(0, 2),
  messages,
});



new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
